import classNames from "classnames";
import { get } from "lodash";
import format from "string-template";
import Card from "./Card";

const EmailTemplate = ({
  civility,
  lastName,
  firstName,
  currentDate,
  adminPhoneNumber,
  adminFirstName,
  adminLastName,
  adminEmail,
  adminAddress,
  translation,
  costs,
  addLinks,
  upsells,
  organization,
}) => {
  return (
    <div className="quote-template-amellis__main-container">
      <div className="quote-template-amellis__header">
        <img
          src={
            get(organization, "icon") ||
            "https://assets.kayros.tech/amellis/logo.png"
          }
          alt={`${get(organization, "name")} Logo`}
        />
      </div>
      <div className="quote-template-amellis__container">
        <div className="quote-template-amellis__content">
          <p>
            {translation.P0} {currentDate}
          </p>
          <p>
            {translation.HELLO}{" "}
            <strong>
              {translation[civility] || civility} {firstName} {lastName}
            </strong>
            ,
          </p>
          <p dangerouslySetInnerHTML={{ __html: translation.P1 }} />
          <p>
            {translation.P2} {currentDate}.
          </p>
          <p>{translation.P3}</p>
          <p>{translation.P4}</p>
        </div>
        <div className="quote-template-amellis__content">
          <p>{translation.BUTTON_INTRO}</p>
          <div className="quote-template-amellis__submit--link">
            <div className="quote-template-amellis__submit">
              {translation.BUTTON}
            </div>
          </div>
        </div>
        <div
          className={classNames("quote-template-amellis__content", {
            hidden: !!addLinks,
          })}
        >
          <p
            dangerouslySetInnerHTML={{
              __html: format(translation.P5_ALT, { adminPhoneNumber }),
            }}
          />
        </div>
        <div className={classNames({ hidden: !addLinks })}>
          <div className="quote-template-amellis__content">
            <p
              dangerouslySetInnerHTML={{
                __html: format(translation.P5, { adminPhoneNumber }),
              }}
            />
          </div>
          {costs?.map(({ id, insurancePlan, cost, currency }) => {
            const insuranceUpsells = get(upsells, insurancePlan.id, []);
            const totalCost = insuranceUpsells.reduce(
              (acc, { cost }) => (acc += cost),
              cost,
            );
            return (
              <Card
                key={id}
                icon={insurancePlan?.icon}
                name={insurancePlan?.name}
                cost={totalCost}
                currency={currency}
                period={translation.PER_MONTH}
                perYear={translation.PER_YEAR}
                allIncluded={translation.ALL_INCLUDED}
                link={translation.LINK}
                upsells={insuranceUpsells}
              />
            );
          })}
        </div>
        <div className="quote-template-amellis__content">
          <p
            dangerouslySetInnerHTML={{
              __html: format(translation.P9, {
                distributorName: get(organization, "name"),
              }),
            }}
          />
          <p>{translation.P10}</p>
          <p className="subtitle">{translation.HELP_TITLE}</p>
          <p>{translation.P6}</p>
          <p>{translation.P7}</p>
          <p>{translation.P8}</p>
        </div>
        <div className="quote-template-amellis__info">
          <p className="quote-template-amellis__info--name">
            {translation.YOUR_ADVISOR}
          </p>
          <p className="quote-template-amellis__info--name">
            {adminFirstName} {adminLastName}
          </p>
          <p>{get(organization, "name")}</p>
          <p>{adminEmail}</p>
          <p>{adminPhoneNumber}</p>
          <p>{adminAddress}</p>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplate;
